module.exports = __webpack_public_path__ + "static/media/down-trend.29eaa70c.svg";